import RunAfter from "./RunAfter";
import RunAsSoonAs from "./RunAsSoonAs";
import RunUntil from "./RunUntil";

const Animation = function (options) {
    this.isActive = false;
    this.name = options && options.name;
    const _name = this.name;
    const animate = options && options.animationFunction;
    const animateAfter = options && options.runAfter;
    const animateAsSoonAs = options && options.runAsSoonAs;
    const animateUntil = options && options.runUntil;
    const animateUntilIf = options && options.runUntilCondition;
    const _start_animate = function (time) {
        this.isActive = true;
        if (animateAfter) {
            if (time > 0) {
                RunAfter(() => {
                    animate(_name);
                }, time || animateAfter);
            } else {
                animate(_name);
            }
        } else if (animateAsSoonAs) {
            RunAsSoonAs(animate, () => animateAsSoonAs);
        } else if (animateUntil) {
            RunUntil(animate, animateUntil, animateUntilIf);
        }
    };
    return {
        start: _start_animate,
        isActive: this.isActive,
        name: this.name
    };
};
export default Animation;
